// extracted by mini-css-extract-plugin
export var priceColumn = "mini-line-item-module--priceColumn--a3216";
export var totals = "mini-line-item-module--totals--fde40";